export default __webpack_public_path__ + "static/media/experience.5f7d3fd5.jpg";